var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home-contract-tx-detail"},[_c('normal-table',{attrs:{"table-data":_vm.tableData,"table-col":_vm.tableCol,"paging":_vm.paging,"show-edit":_vm.showEdit,"operator":_vm.operator,"operate-col":_vm.operatorCol},on:{"pagination":_vm.getTxnListFn}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }